import React from "react";
import { View } from "react-native";

const CustomerVoice = () => {
    return (
        <View style={{ flex: 1, backgroundColor: '#e6e6e6' }}>

        </View>
    )
}
export default CustomerVoice;